import { Box, Stack, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

import linkedinIcon from "../../assets/icon/linkedin.svg";
import githubIcon from "../../assets/icon/github.svg";
import stackoverflowIcon from "../../assets/icon/stackoverflow.svg";
import "../../assets/css/home.css";

const Home = () => {
  return (
    <div className="bg-extra-light-blue h-100">
      <div className="slide-overlay"></div>
      <div className="container-fluid main-layout h-100 bg-cream py-3">
        <Stack
          className="h-100"
          justifyContent="center"
          direction="column"
        >
          <Stack
            className="w-100 personal-detail"
            justifyContent="space-evenly"
            direction="row"
            flexWrap="wrap"
            spacing={2}
          >
            <Stack
              direction="column"
              alignItems="start"
              justifyContent="end"
              flexWrap="wrap"
              maxWidth={360}
            >
              <Stack
                direction="column"
                mb={3}
              >
                <Typography
                  className="josefin-sans text-uppercase pb-2 light-blue"
                  variant="h6"
                  component="h6"
                >
                  Vishal Gajera
                </Typography>
                <Typography
                  className="josefin-sans pb-2 light-blue"
                  fontSize={14}
                  variant="h6"
                  component="h6"
                >
                  Strategic Web Designer and Web Developer
                </Typography>
                <Typography
                  className="josefin-sans pb-2 light-blue"
                  fontSize={14}
                  variant="h6"
                  component="h6"
                >
                  With over 4 years’ of hands-on experience in software development, I possess a
                  versatile skill set spanning various technologies, with expertise in both frontend
                  and backend development. I have a proven track record of seamlessly collaborating
                  within teams, leveraging effective communication and leadership skills to manage
                  remote developers. Additionally, I am adept at independently spearheading projects
                  from inception to completion, ensuring timely delivery and impeccable quality.
                </Typography>
                <Typography
                  className="josefin-sans light-blue"
                  fontSize={14}
                  variant="h6"
                  component="h6"
                >
                  Currently working as a Senior Fronted Developer at{" "}
                  <span className="company-name">Coax Creative</span>.
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction="column"
              alignItems="end"
              justifyContent="center"
            >
              <Box>
                <NavLink
                  to="/work"
                  className="text-decoration-none"
                >
                  <Typography
                    className="home-list text-uppercase light-blue fw-normal dancing-font"
                    variant="h1"
                    component="h1"
                  >
                    Work
                  </Typography>
                </NavLink>
                <NavLink
                  to="/about-me"
                  className="text-decoration-none"
                >
                  <Typography
                    className="home-list text-uppercase light-blue fw-normal dancing-font"
                    variant="h1"
                    component="h1"
                  >
                    About
                  </Typography>
                </NavLink>
                <NavLink
                  to="/contact-me"
                  className="text-decoration-none"
                >
                  <Typography
                    className="home-list text-uppercase light-blue fw-normal dancing-font"
                    variant="h1"
                    component="h1"
                  >
                    Contact
                  </Typography>
                </NavLink>
              </Box>
            </Stack>
          </Stack>
          <Stack
            direction="column"
            alignItems="center"
            className="nav-right"
            justifyContent="space-between"
          >
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              className="nav-right-first"
            >
              <Box className="nav-right-item transform-none">
                <NavLink
                  target="_blank"
                  className="nav-right-link josefin-sans light-blue fw-bold"
                  to="https://www.linkedin.com/in/vishal-gajera-3b51b0208/"
                >
                  <img
                    className="img-shadow"
                    src={linkedinIcon}
                    alt=""
                  />
                </NavLink>
              </Box>
              <Box className="nav-right-item transform-none">
                <NavLink
                  target="_blank"
                  to="https://github.com/devVishalGajera"
                  className="nav-right-link josefin-sans light-blue fw-bold"
                >
                  <img
                    className="img-shadow-black"
                    src={githubIcon}
                    alt=""
                  />
                </NavLink>
              </Box>
              <Box className="nav-right-item transform-none">
                <NavLink
                  target="_blank"
                  to="https://stackoverflow.com/users/21631269/vishal-gajera?tab=profile"
                  className="nav-right-link josefin-sans light-blue fw-bold"
                >
                  <img
                    className="img-shadow-black"
                    src={stackoverflowIcon}
                    alt=""
                  />
                </NavLink>
              </Box>
              <Box className="nav-line bg-dark-blue" />
            </Stack>
            <Box className="nav-right-item">
              <Typography className="josefin-sans nav-item-n-link light-blue fw-bold">
                @/2023
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};
export default Home;
